import React, { Key, useCallback, useEffect, useState } from 'react'
import './CareersDetails.scss'
import { BreadCrumb, HorizontalLoader, LineList } from 'Components'
import Swal from 'sweetalert2'
import { leaveService } from 'Services/leaveService'
import { useForm } from 'react-hook-form'
import { leaveType } from 'Models/leaveType'
import { useEmployeeProfile } from 'Context/ProfileContext'
import { DateConverterWord, IsOneYearOrMore, TableSerialNumber } from 'Helpers'
import { useSelector } from 'react-redux'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { DownloadSvg, FilterSvg, SearchSvgMuted } from 'Components/Svgs'
import { dummyCareers, resReq } from 'Data/dummy_careers'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import careerService from 'Services/careerService'
import { CandidatePipeline } from 'Pages/Frontend/Components'
import HorizontalDots from 'Components/Svgs/ThreeHorizontalDots'
import { IJobResponse } from 'Models'

function CareersDetails() {
  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  if (!id) return null

  const role = useSelector((state: any) => state.role)
  // const { user } = useAuth()
  // const isHr = role === 'hr' || user?.role === 'hr' ? true : false

  // const { profile } = useEmployeeProfile()

  // const isEmployeeExactlyAYearOrMoreThanAYear = IsOneYearOrMore(profile?.employmentDate)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const [request, setRequest] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [leave, setLeave] = useState<IJobResponse>()
  const [allApps, setAllApps] = useState<IJobResponse>()

  const { register } = useForm()
  const [sortOrder, setSortOrder] = useState('DESC')
  const [status, setStatus] = useState<string | undefined>(undefined)
  const [hrApprovalStatus, setHrApprovalStatus] = useState<string | undefined>(undefined)

  const handleReset = (e: any) => {
    e.preventDefault()
    setStatus(undefined)
    setHrApprovalStatus(undefined)
  }
  const empty = status || hrApprovalStatus

  const getAllApps = async () => {
    setRequest(true)
    await careerService.getJobApplicationsSubmitted().then(
      (data) => {
        console.log('r', data.data.data)
        setAllApps(data.data.data)
        setRequest(false)

        setPaginationData({
          pageNumber: data?.data.data.pageNumber,
          pageSize: data?.data.data.pageSize,
          total: data?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        // console.log('leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    getAllApps()
  }, [])

  const getLeave = async () => {
    setRequest(true)
    await careerService.getSingleJob(id).then(
      (data) => {
        // console.log('r', data.data.data)
        setLeave(data.data.data)
        setRequest(false)

        setPaginationData({
          pageNumber: data?.data.data.pageNumber,
          pageSize: data?.data.data.pageSize,
          total: data?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        // console.log('leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    getLeave()
  }, [id])

  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const leaveAction = async (leaveId: string | undefined, action: string) => {
    Swal.fire({
      title: 'Alert?',
      text: `Are you sure you want to ${action === 'DRAFT' ? 'keep as draft?' : action === 'OPEN' ? 'publish' : 'close'} ${action === 'DRAFT' ? '' : 'this application?'} `,
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.showLoading()
        await careerService.updateJobStatus(leaveId, action).then(
          () => {
            getLeave()
            Swal.fire({
              icon: 'success',
              title: 'Done!',
              text: `Application ${action === 'DRAFT' ? 'kept as draft' : action} succesfully!`,
              showConfirmButton: false,
              timer: 3000,
            })
            Swal.hideLoading()
          },
          (error: { response: { data: { error: string } } }) => {
            Swal.hideLoading()
            console.log('leaveService', error)
            setRequest(false)
            Swal.fire({
              icon: 'warning',
              title: 'Oops!',
              text: error.response.data.error,
              showConfirmButton: false,
              timer: 3000,
            })
          },
        )
      }
    })
  }

  function formatString(str: string) {
    return (
      str
        // Split the string by underscores
        .split('_')
        // Capitalize the first letter of each word
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        // Join the words back with a space
        .join(' ')
    )
  }

  const [activeProduct, setActiveProduct] = useState()
  const [product, setProduct] = useState()

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const activeTab = searchParams.get('tab') || 'ALLJOBS'
  const [tradingMode, setProductLocation] = useState('ALLJOBS')

  const handleTabChange = (tab: string) => {
    navigate(`?tab=${tab}`)
    setProductLocation(tab)
  }

  const fetchProducts = useCallback(async () => {
    setLoading(true)
    await careerService.index(pageNumber, sortOrder, tradingMode).then(
      (response) => {
        setLoading(false)
        setProduct(response?.data.data.dataset)
        setActiveProduct(response?.data.data.dataset[0])
        console.log({ response })
      },
      (error) => {
        setLoading(false)
        console.log(error)
      },
    )
  }, [pageNumber, sortOrder, tradingMode])

  //   useEffect(() => {
  //     fetchProducts()
  //   }, [sortOrder, tradingMode, fetchProducts])

  return (
    <div className='CareersAdmin CareersDetails'>
      <div className='container'>
        <BreadCrumb
          title={'Job Details'}
          parent={'Jobs'}
          parentUrl={'/careers'}
          showTitle={false}
        ></BreadCrumb>
      </div>
      <div className='container mt-3'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0'>
              <div className='row'>
                <div className='col-6 col-md-6 my-auto'>
                  <div className='d-flex gap-2 align-items-center'>
                    <div className='title details'>{leave?.title}</div>{' '}
                    <span
                      // className={`${
                      //   data.status === 'Closed'
                      //     ? 'rejected'
                      //     : data.status === 'Draft'
                      //       ? 'pending'
                      //       : ['Published', 'COMPLETED'].includes(data.status)
                      //         ? 'status'
                      //         : ''
                      // }`}
                      className='status d-flex align-items-center justify-content-center'
                    >
                      {leave?.status === 'OPEN' ? 'Published' : leave?.status}
                    </span>
                  </div>
                  <div className='sub-title details d-flex justify-content-between'>
                    <span>{leave?.department}</span>
                    <span>·</span>
                    <span>{leave?.employmentType}</span>
                    <span>·</span>
                    <span>{leave?.location}</span>
                  </div>
                </div>
                <div className='col-6 col-md-6 text-end justify-content-end align-items-center gap-3 d-flex d-non'>
                  <Link to={`/admin/edit-job/${leave?.id}`}>
                    <button className='btn btn-job back'>Edit Job</button>
                  </Link>

                  <div className='dropdown option-dropdown'>
                    <button
                      className='btn x-toggle-con'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                      data-bs-popper-config='{"strategy":"fixed"}'
                    >
                      <HorizontalDots />
                    </button>

                    <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                      <li className='dropdown-item' onClick={() => leaveAction(leave?.id, 'OPEN')}>
                        Publish
                      </li>
                      <li
                        className='dropdown-item draft'
                        onClick={() => leaveAction(leave?.id, 'DRAFT')}
                      >
                        Draft
                      </li>
                      <li
                        className='dropdown-item text-danger'
                        onClick={() => leaveAction(leave?.id, 'CLOSED')}
                      >
                        CLOSED
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className='border card-body top-card mt-4'>
                <div className='row'>
                  <div className='col'>
                    <div className='key'>Hiring Manager</div>
                    <div className='value mt-2'>-</div>
                    <div className='key mt-4'>Posted</div>
                    <div className='value mt-2'>{leave?.updatedAtISO8601}</div>
                  </div>
                  <div className='col'>
                    <div className='key'>Recruiter</div>
                    <div className='value mt-2'>-</div>
                    <div className='key mt-4'>Application Deadline</div>
                    <div className='value mt-2'>-</div>
                  </div>
                  <div className='col'>
                    <div className='key'>Openings</div>
                    <div className='value mt-2'>{leave?.applicationsCount}</div>
                    <div className='key mt-4'>Salary Range</div>
                    <div className='value mt-2'>-</div>
                  </div>
                </div>
              </div>

              <div className='row h-100 gx-0'>
                <div className='col-md-12 my-auto'>
                  <ul className='nav details nav-tabs gx-0 justify-content-between'>
                    <li className='nav-item'>
                      <button
                        className={`nav-link  px-0 me-3 ${activeTab === 'OVERVIEW' ? 'active' : ''}`}
                        onClick={() => handleTabChange('OVERVIEW')}
                      >
                        Overview
                      </button>
                    </li>
                    <li className='nav-item'>
                      <button
                        className={`nav-link  px-0 ms-3 ${activeTab === 'APPLICATIONS' ? 'active' : ''}`}
                        onClick={() => handleTabChange('APPLICATIONS')}
                      >
                        Applications
                      </button>
                    </li>
                    <li className='nav-item'>
                      <button
                        className={`nav-link  px-0 ms-3 ${activeTab === 'JOBDESC' ? 'active' : ''}`}
                        onClick={() => handleTabChange('JOBDESC')}
                      >
                        Job Description
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='row mt-2 d-none'>
                <div className='col-12 col-md-8'>
                  <div className='search-field'>
                    <span>
                      <SearchSvgMuted />
                    </span>

                    <input
                      type='text'
                      className='form-control'
                      placeholder='Search jobs'
                      {...register('employeeName')}
                    />
                  </div>
                </div>
                <div className='col-6 col-md-2 dropdown'>
                  <button
                    className='btn btn-filter dropdown-toggle'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    <FilterSvg />
                    Filters
                  </button>
                  <div className='dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown'>
                    <div className='dropdown-item h-100'>
                      <form action=''>
                        <div className='form-group'>
                          <label htmlFor=''>Sort List</label>
                          <select
                            id=''
                            className='form-control'
                            onChange={(e: any) => {
                              setSortOrder(e.target.value)
                            }}
                          >
                            <option value='DESC'>Descending Order</option>
                            <option value='ASC'>Ascending Order</option>
                          </select>
                        </div>
                        <div className='form-group mt-3'>
                          <label htmlFor=''>Status</label>
                          <select
                            id=''
                            value={status || ''}
                            className='form-control'
                            onChange={(e: any) => {
                              setStatus(e.target.value || undefined)
                            }}
                          >
                            <option disabled value=''>
                              ---select---
                            </option>
                            <option value='PENDING_APPROVAL'>Pending Approval</option>
                            <option value='APPROVED'>Approved</option>
                            <option value='REJECTED'>Rejected</option>
                            <option value='ON_GOING'>On Going</option>
                            <option value='COMPLETED'>Completed</option>
                          </select>
                        </div>
                        <div className='form-group mt-3'>
                          <label htmlFor=''>Hr Status</label>
                          <select
                            id=''
                            value={hrApprovalStatus || ''}
                            className='form-control'
                            onChange={(e: any) => {
                              setHrApprovalStatus(e.target.value || undefined)
                            }}
                          >
                            <option disabled value=''>
                              ---select---
                            </option>
                            <option value='PENDING_HR_APPROVAL'>Pending Hr Approval</option>
                            <option value='APPROVED'>Approved</option>
                            <option value='REJECTED'>Rejected</option>
                          </select>
                        </div>

                        <div className='row mt-3'>
                          <div className='col-md-6'>
                            <button
                              disabled={!empty}
                              onClick={handleReset}
                              className='btn btn-reset'
                            >
                              Reset
                            </button>
                          </div>
                          <div className='col-md-6 text-end d-none'>
                            <button className='btn btn-filter'>Filter</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className='col-6 col-md-2 dropdown'>
                  <button
                    className='btn btn-export dropdown-toggle'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    <DownloadSvg />
                    Export
                  </button>

                  <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                    <li className='dropdown-item'> Export as .pdf</li>
                    <li className='dropdown-item'> Export as .xlsx</li>
                    <li className='dropdown-item'> Export as .doc </li>
                  </ul>
                </div>
              </div>
              <h6 className='mt-2 ps-1'>Candidate Pipeline</h6>
            </div>
            <div
              className={`${activeTab === 'OVERVIEW' || activeTab === 'ALLJOBS' ? '' : 'card-body'}`}
            >
              {(activeTab === 'OVERVIEW' || activeTab === 'ALLJOBS') && <CandidatePipeline />}
              {activeTab === 'APPLICATIONS' && (
                <div className='table-responsive'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <td>Candidate</td>
                        <td>Applied</td>
                        <td>Experience</td>
                        <td>Location</td>
                        <td>Stage</td>
                        <td>Reviewer</td>
                        <td>Last Updated</td>
                        <td>Action</td>
                      </tr>
                    </thead>
                    <tbody>
                      {dummyCareers &&
                        dummyCareers.map((data: any, index: Key) => (
                          <tr key={index}>
                            <td className='d-flex gap-2'>
                              <div className='small-circle-gray'>SA</div>
                              <div>
                                <div className='job-name'>Sarah Adeyemi</div>
                                <div className='job-role-name'>
                                  <span>Senior Designer</span>
                                  <span>·</span>
                                  <span>sarah.adeyemi@mail.com</span>
                                </div>
                              </div>
                            </td>
                            <td>Sep 9</td>
                            <td>3 yrs</td>
                            <td>Lagos, Nigeria</td>
                            <td>Applied</td>
                            <td>Chidinma Eze</td>
                            <td>{DateConverterWord(data.posted)}</td>
                            <td className='dropdown option-dropdown'>
                              <button
                                className={`btn border-0 dropdown-toggle ${['REJECTED', 'APPROVED'].includes(data.status) ? 'disabled' : ''}`}
                                data-bs-toggle='dropdown'
                                aria-expanded='false'
                                data-bs-popper-config='{"strategy":"fixed"}'
                              >
                                <svg
                                  width='18'
                                  height='18'
                                  viewBox='0 0 18 18'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                    fill='#707070'
                                  />
                                  <path
                                    d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                    fill='#707070'
                                  />
                                  <path
                                    d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                    fill='#707070'
                                  />
                                </svg>
                              </button>

                              {/* <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                              {!isEmployeeExactlyAYearOrMoreThanAYear &&
                              isHr &&
                              data.hrApprovalStatus === 'PENDING_HR_APPROVAL' ? (
                                <li
                                  className='dropdown-item'
                                  onClick={() => leaveAction(data.id, 'approve')}
                                >
                                  Approve
                                </li>
                              ) : (
                                !isHr &&
                                data.hrApprovalStatus === 'APPROVED' && (
                                  <li
                                    className='dropdown-item'
                                    onClick={() => leaveAction(data.id, 'approve')}
                                  >
                                    Approve
                                  </li>
                                )
                              )}

                              {['PENDING_APPROVAL'].includes(data.status) && (
                                <li
                                  className='dropdown-item text-danger'
                                  onClick={() => leaveAction(data.id, 'reject')}
                                >
                                  Reject
                                </li>
                              )}
                            </ul> */}
                            </td>
                          </tr>
                        ))}

                      {loading === false && leave === undefined && (
                        <tr>
                          <td colSpan={9} className='text-center'>
                            No leave found
                          </td>
                        </tr>
                      )}
                      {loading === true && leave === undefined && (
                        <tr>
                          <td colSpan={9} className='text-center'>
                            <HorizontalLoader></HorizontalLoader>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
              {activeTab === 'JOBDESC' && (
                <div>
                  <section className='second-con mt- mb-2'>
                    <div className='about-role'>
                      <h4>About the Role</h4>
                      <p className='mt-3'> {leave?.description ?? '-'}</p>
                    </div>
                    <div className='about-role mt-3 pt-3'>
                      <h4>Responsibilities</h4>
                      <ul className='list-group list-group-flush mt-3 ps-4'>
                        <LineList
                          value={
                            leave && leave?.details?.responsibilities?.length > 0
                              ? leave?.details?.responsibilities
                              : '-'
                          }
                          className='d-fle justify-content-between list-req'
                        />
                      </ul>
                    </div>
                    <div className='about-role mt-3 pt-3'>
                      <h4>Requirements</h4>
                      <ul className='list-group list-group-flush mt-3 ps-4'>
                        <LineList
                          value={
                            leave && leave?.details?.requirements?.length > 0
                              ? leave?.details?.requirements
                              : '-'
                          }
                          className='d-fle justify-content-between list-req'
                        />
                      </ul>
                    </div>
                    <div className='about-role mt-3 pt-3'>
                      <h4>Skills</h4>
                      <ul className='list-group list-group-flush mt-3 ps-4'>
                        <LineList
                          value={
                            leave && leave?.details?.skills?.length > 0
                              ? leave?.details?.skills
                              : '-'
                          }
                          className='d-fle justify-content-between list-req'
                        />
                      </ul>
                    </div>
                    <div className='about-role mt-3 pt-3'>
                      <h4>About Tradegrid</h4>
                      <p className='mt-3'> -</p>
                    </div>
                  </section>
                </div>
              )}

              {/* {paginationData.total >= paginationData.pageSize && (
                <div className='pagination w-100 d-flex justify-content-center'>
                  {paginationData.total && (
                    <Pagination
                      className='pagination-bar ps-0'
                      currentPage={Number(paginationData.pageNumber)}
                      totalCount={paginationData.total}
                      pageSize={paginationData.pageSize}
                      onPageChange={(page: React.SetStateAction<number>) => setPageNumber(page)}
                    />
                  )}
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>

      {/* <ModalWrapper showModal={showModal} closeModal={toggleModal} title='Leave Application'>
        <LeaveForm toggle={() => toggleModal()}></LeaveForm>
      </ModalWrapper> */}
    </div>
  )
}

export default CareersDetails
